export default {
    device_overview_title: 'Dispositivo',
    device_overview_actions: 'Acciones',
    device_overview_device_name: 'Nombre del Dispositivo',
    device_overview_status: 'Estado',
    device_overview_iccid: 'ICCID',
    device_overview_imei: 'IMEI',
    device_overview_serial: 'Serial',
    device_overview_account: 'Cuenta',
    device_overview_created_by: 'Creador Por',
    device_overview_network: 'NetworkRed',
    device_overview_device_model: 'Model del Dispositivo',
    device_overview_manufacturer: 'Fabricante',
    device_overview_sim_phone: 'Teléfono de la SIM',
    device_overview_created_at: 'Creado En',
    device_overview_unit_time: 'Fecha del Dispositivo',
    device_overview_server_time: 'Fecha del Servidor',
    device_overview_last_message_time: 'Fecha del Último Mensaje',
    device_overview_age: 'Edad',
    device_overview_sim_provider_account: 'Cuenta del Proveedor de la SIM',
    device_overview_script: 'Script',
    device_overview_device_category: 'Categoría del Dispositivo',
    device_overview_rma_number: 'Número de RMA',
    device_overview_refurbish_from: 'Remanufacturado de',
    device_overview_activities: 'Actividades',
    device_overview_raw_data: 'Datos Sin Procesar',
    device_overview_script: "Script",
    device_overview_puls_customer: "Cuenta Calamp",
    device_overview_firmware: "Firmware",
    device_overview_edit: "Editar",
    device_overview_live_streaming: "Transmisión en Vivo",

    device_overview_edit_sim_card: 'Editar & Cambiar Sim Card',
    device_overview_change_device_script: "Cambiar el Script del Dispositivo",
    device_overview_mark_as_rma: "Marcar como RMA",
    device_overview_send_command: "Enviar Comando",
    device_overview_change_sim_provider: "Cambiar Proveedor de SIM",
    device_overview_change_puls_customer: "Cambiar la Cuenta Calamp",
    
    device_overview_tab_command: "Comandos",
    device_overview_tab_features: "Caracteristicas",
    device_overview_tab_troubleshooting_events: "Resolución de Problemas",
    device_overview_device_not_found: "Dispositivo no Encontrado",
    device_overview_device_overview: "Descripción del Dispositivo",
    device_overview_tab_vidfleet_configuration: "Configuración VidFleet",
    
    device_overview_calamp_info: "Calamp",
    device_overview_refurbish_message: "Clic para ver el dispositivo original",
    device_overview_activate_camera_sim_card: "Activar la Tarjeta SIM de la Cámara",

    device_overview_format_sd_card: "Formatear la tarjeta SD",
    device_overview_unpairing_the_gps: "Desemparejar el gps",
    device_overview_associate_to_gps: "Emparejar Dispositivo",
    device_overview_request_device_log: "Solicitar el Registro de Dispositivos",
    device_overview_linked_device_esn: "Dispositivo Emparejado",
    device_overview_device_linked_to: "Dispositivo emparejado a",
    device_overview_sim_info: "Información de la SIM",
    device_overview_refurbish: "Restaurar este Dispositivo",
    device_overview_device_refurbish: "Dispositivo Restaurado",
    device_overview_camera_mode: "Modo",
    device_overview_refurbish_message: "El dispositivo remanufacturado no puede ser editado",
    device_overview_rma_message: "Dispositivo en RMA no puede ser editado",
    device_overview_unpair_device: "Desemparejar el dispositivo",
    device_overview_tab_notes: "Notas",
    device_overview_refresh_config: "Refrescar la configuración",
    device_overview_refresh_config_message: "La configuración del dispositivo ha sido refrescada",
    device_overview_refresh_cameras_device_config: "Refrescar la configuración del dispositivo",
    device_overview_device_timezone: "Zona Horaria",
    device_overview_show_web: "Mostrar en la web",
    device_overview_puls_group: "Grupo",
    device_overview_assigned_script: "Script Asignado",
    device_overview_refurbished_pool: "Remanufacturados",
    device_overview_installed: "Instalado",
    device_overview_pending_installed: "Instalación Pendiente",
    device_overview_installed_on: "Fecha Instalación",
    device_overview_coverage_score: "Puntaje de Diagnóstico",
    device_overview_converage_updated_on: "Actualización de la Cobertura",
    device_overview_create_diagnostic: "Crear Diagnóstico",
    device_overview_clip_request: "Solicitud de Clips",
    device_overview_battery_level: "Nivel de Batería",
    device_overview_camera_warning: "El estado de la SD Card es",
    device_overview_billing_account: "Cuenta de Facturación",
};


